import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import {
  Box,
  Grid,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import CnpjTextField from "../../../../../components/react-form/CnpjTextField";

export default function BankAccountFieldset({ index, disabled, onRemove, canRemove }) {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const ns = `bankAccounts.${index}`;
  const e = errors.bankAccounts?.[index] ?? {};

  return (
    <Box
      component="fieldset"
      sx={{ border: "1px solid", borderColor: "divider", borderRadius: 2, p: 2, mb: 1, "& legend": { px: 1 } }}
    >
      <Box component="legend" sx={{ display: "flex", alignItems: "center", gap: 1, width: "auto !important" }}>
        <Typography sx={{ fontWeight: 700, fontSize: "13px", color: "text.secondary" }}>
          Banco {index + 1}
        </Typography>
        {canRemove && !disabled && (
          <IconButton onClick={onRemove} color="error" size="small">
            <DeleteIcon fontSize="small" />
          </IconButton>
        )}
      </Box>
      <Grid container spacing={1.5}>
        <Grid item xs={12}>
          <Controller
            name={`${ns}.cnpj`}
            control={control}
            render={({ field }) => (
              <CnpjTextField
                {...field}
                required disabled={disabled}
                label="CNPJ"
                variant="outlined"
                size="small"
                fullWidth
                error={!!e.cnpj}
                helperText={e.cnpj?.message}
              />
            )}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <Controller
            name={`${ns}.bank`}
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                required disabled={disabled}
                label="Banco"
                variant="outlined"
                size="small"
                fullWidth
                error={!!e.bank}
                helperText={e.bank?.message}
              />
            )}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <Controller
            name={`${ns}.agency`}
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                required disabled={disabled}
                label="Agência"
                variant="outlined"
                size="small"
                fullWidth
                error={!!e.agency}
                helperText={e.agency?.message}
              />
            )}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <Controller
            name={`${ns}.account`}
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                required disabled={disabled}
                label="Conta"
                variant="outlined"
                size="small"
                fullWidth
                error={!!e.account}
                helperText={e.account?.message}
              />
            )}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <Controller
            name={`${ns}.agreementCode`}
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                required disabled={disabled}
                label="Cód Convênio"
                variant="outlined"
                size="small"
                fullWidth
                error={!!e.agreementCode}
                helperText={e.agreementCode?.message}
              />
            )}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
